import React from 'react';
import styles from './errorMessage.scss';

export const ErrorMessage = ({ message }) => (
  <span className={styles.errorMessage}>{message}</span>
);
